import { configureStore } from '@reduxjs/toolkit'
import sessionSlice from './slices/session.slice'
import filterSlice from './slices/filter.slice'

export const store = configureStore({
  reducer: {
    session: sessionSlice,
    filter: filterSlice
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
